/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Importing_TracksInputs */



/**
* | output |
* | --- |
* | "Importing tracks..." |
*
* @param {Work_Order_Import_Status_Importing_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_importing_tracks = /** @type {((inputs?: Work_Order_Import_Status_Importing_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Importing_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des pistes...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Titel werden importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione delle tracce...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт треков...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando pistas...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入曲目……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक आयात किए जा रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando faixas...")
	return /** @type {LocalizedString} */ ("Importing tracks...")
});